export const rotatePath = (arr: any[], rotation: number) => {
  switch (rotation) {
    case 90:
      return arr.map(item => item.reverse())
    case 180:
      return arr.map(item => [-item[0], -item[1]])
    case 270:
      return arr.map(item => [-item[1], -item[0]])
  }
}
